import React, { useState, useEffect } from "react";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./archive.css";

const Billing = () => {
  const [pagamenti, setPagamenti] = useState([]);
  const [users, setUsers] = useState([]);
  const [tipiProva, setTipiProva] = useState([]);
  const [selectedUser, setSelectedUser] = useState("");
  const [selectedTipoProva, setSelectedTipoProva] = useState("");
  const [quantita, setQuantita] = useState(1);
  const [totaleGenerale, setTotaleGenerale] = useState(0);
  const [isAdmin, setIsAdmin] = useState(false); // ✅ stato per admin

  const token = localStorage.getItem("token");

  useEffect(() => {
    fetchPagamenti();
    // fetchUsers e fetchTipiProva solo se sei admin
    if (isAdmin) {
      fetchUsers();
      fetchTipiProva();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAdmin]); // aggiorna fetchUsers solo quando isAdmin cambia

  // ====== FETCH PAGAMENTI ======
  const fetchPagamenti = async () => {
    if (!token) {
      console.error("Token mancante!");
      toast.error("Token mancante", { autoClose: 2000 });
      return;
    }

    try {
      const res = await axios.get("https://www.hat.sofhare.com/pagamenti/", {
        headers: { Authorization: `Bearer ${token}` },
      });

      const elaborazioni = res.data.elaborazioni || [];
      const totale = res.data.totale || 0;
      const isAdminFromBackend = res.data.is_superuser || false;

      setPagamenti(elaborazioni);
      setTotaleGenerale(totale);
      setIsAdmin(isAdminFromBackend); // ✅ aggiorna lo stato admin
      localStorage.setItem("is_superuser", isAdminFromBackend); // opzionale
    } catch (err) {
      console.error("Errore caricamento pagamenti:", err);
      toast.error("Errore caricamento pagamenti", { autoClose: 2000 });
    }
  };

  // ====== FETCH UTENTI (solo admin) ======
  const fetchUsers = async () => {
    try {
      const res = await axios.get("https://www.hat.sofhare.com/users/", {
        headers: { Authorization: `Bearer ${token}` },
      });
      setUsers(res.data);
    } catch (err) {
      toast.error("Errore caricamento utenti", { autoClose: 2000 });
    }
  };

  // ====== FETCH TIPI PROVA (solo admin) ======
  const fetchTipiProva = async () => {
    try {
      const res = await axios.get("https://www.hat.sofhare.com/tipi-prova/", {
        headers: { Authorization: `Bearer ${token}` },
      });
      setTipiProva(res.data);
      console.log(res.data)
    } catch (err) {
      toast.error("Errore caricamento tipi prova", { autoClose: 2000 });
    }
  };

  // ====== INSERIMENTO NUOVA PROVA ======
  const handleAddProva = async (e) => {
    e.preventDefault();
    if (!selectedUser || !selectedTipoProva || quantita <= 0) {
      toast.error("Seleziona utente, tipo prova e quantità valida");
      return;
    }
    try {
      await axios.post(
        "https://www.hat.sofhare.com/pagamenti/",
        {
          user_id: selectedUser,
          tipo_prova_id: selectedTipoProva,
          quantita,
        },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      toast.success("Prova aggiunta", { autoClose: 1500 });
      setSelectedUser("");
      setSelectedTipoProva("");
      setQuantita(1);
      fetchPagamenti();
    } catch (err) {
      toast.error("Errore aggiunta prova", { autoClose: 2000 });
    }
  };

  // ====== AZZERAMENTO PAGAMENTI ======
  const handleAzzera = async (userId) => {
    if (!window.confirm("Vuoi azzerare i pagamenti di questo utente?")) return;
    try {
      await axios.post(
        `https://www.hat.sofhare.com/pagamenti/azzera/${userId}/`,
        {},
        { headers: { Authorization: `Bearer ${token}` } }
      );
      toast.success("Pagamenti azzerati", { autoClose: 1500 });
      fetchPagamenti();
    } catch (err) {
      toast.error("Errore azzeramento", { autoClose: 2000 });
    }
  };

  return (
    <div className="main-wrapper">
      <ToastContainer />

      {/* ====== FORM ADMIN ====== */}
      {isAdmin && (
        <div className="tools-wrapperS1-arch">
          <h1 className="archivio-title">Gestione crediti</h1>
          <form onSubmit={handleAddProva} className="upload-form">
            <div className="upload-row">
              <div className="upload-col-left">
                <label>Seleziona Utente:</label>
                <select
                  value={selectedUser}
                  onChange={(e) => setSelectedUser(e.target.value)}
                >
                  <option value="">--Seleziona--</option>
                  {users.map((u) => (
                    <option key={u.id} value={u.id}>
                      {u.username}
                    </option>
                  ))}
                </select>

                <label>Tipo Prova:</label>
                <select
                  value={selectedTipoProva}
                  onChange={(e) => setSelectedTipoProva(e.target.value)}
                >
                  <option value="">--Seleziona--</option>
                  {tipiProva.map((tp) => (
                    <option key={tp.id} value={tp.id}>
                      {tp.nome} (€{tp.prezzo_unitario})
                    </option>
                  ))}
                </select>

                <label>Quantità:</label>
                <input
                  type="number"
                  min={1}
                  value={quantita}
                  onChange={(e) => setQuantita(e.target.value)}
                />

                <button type="submit">Aggiungi Prova</button>
              </div>
            </div>
          </form>
        </div>
      )}

      {/* ====== LISTA PAGAMENTI ====== */}
      <div className="tools-wrapperS1-arch">
        <h1 className="archivio-title">Lista elaborazioni</h1>
        <table className="files-table">
          <thead>
            <tr>
              {isAdmin && <th>Utente</th>}
              <th>Tipo Prova</th>
              <th>Quantità</th>
              <th>Prezzo Unitario</th>
              <th>Totale</th>
              {isAdmin && <th>Azzeramento</th>}
            </tr>
          </thead>
          <tbody>
          {pagamenti
            .sort((a, b) => a.saldato - b.saldato) // non pagati prima (false=0, true=1)
            .map((p) => (
              <tr
                key={p.id}
                style={{
                  backgroundColor: p.saldato ? "#d4edda" : "#fff3cd", // verde chiaro se pagato, arancione chiaro se non pagato
                }}
              >
                {isAdmin && <td>{p.user_nome}</td>}
                <td>{p.tipo_prova_nome}</td>
                <td>{p.quantita}</td>
                <td>€{p.prezzo_unitario}</td>
                <td>€{p.totale}</td>

                {isAdmin && !p.saldato && (
                  <td>
                    <button onClick={() => handleAzzera(p.user)}>
                      Segna come pagato
                    </button>
                  </td>
                )}
                {isAdmin && p.saldato && <td></td>} {/* cella vuota per righe già pagate */}
              </tr>
            ))}
        </tbody>
        </table>
        <p>
          <strong>Totale Complessivo: €{totaleGenerale}</strong>
        </p>
      </div>
    </div>
  );
};

export default Billing;